var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#8644B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 26.25H23.5C23.1353 26.25 22.7856 26.3949 22.5277 26.6527C22.2699 26.9106 22.125 27.2603 22.125 27.625V51C22.125 51.7293 22.4147 52.4288 22.9305 52.9445C23.4462 53.4603 24.1457 53.75 24.875 53.75H55.125C55.8543 53.75 56.5538 53.4603 57.0695 52.9445C57.5853 52.4288 57.875 51.7293 57.875 51V27.625C57.875 27.2603 57.7301 26.9106 57.4723 26.6527C57.2144 26.3949 56.8647 26.25 56.5 26.25ZM52.9645 29L40 40.8852L27.0355 29H52.9645ZM55.125 51H24.875V30.7514L39.0702 43.7641C39.3238 43.9969 39.6556 44.1261 40 44.1261C40.3444 44.1261 40.6762 43.9969 40.9298 43.7641L55.125 30.7514V51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b4b6a298e56944e0acf69fd1123b9fa0.svg";
export { ForwardRef as ReactComponent };